<template>
  <div class="pageStyle">
    <div class="content">
      <div class="title">{{ isAdd ? "新增" : "修改" }}夹层码</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.layerName"
          name="夹层名称"
          label="夹层名称"
          placeholder="请填写夹层名称"
          :rules="[{ required: true, message: '请填写夹层名称' }]"
        />
        <van-field
          v-model="form.upstreamName"
          name="上游名称"
          label="上游名称"
          placeholder="请填写上游名称"
        />
        <van-field
          v-model="form.notes"
          name="二维码备注"
          label="二维码备注"
          placeholder="请填写二维码备注"
        />
        <van-field
          v-model="form.backgroundColor"
          name="背景颜色"
          label="背景颜色"
          readonly
          :rules="[{ required: true, message: '请点击右侧选择背景颜色' }]"
        >
          <template #button>
            <div
              class="colorPickerDiv"
              :style="{ backgroundColor: form.backgroundColor }"
              @click="
                showColorPicker = !showColorPicker;
                changeColorType = 1;
              "
            ></div>
          </template>
        </van-field>
        <van-field
          v-model="form.fontColor"
          name="字体颜色"
          label="字体颜色"
          readonly
          :rules="[{ required: true, message: '请点击右侧选择字体颜色' }]"
        >
          <template #button>
            <div
              class="colorPickerDiv"
              :style="{ backgroundColor: form.fontColor }"
              @click="
                showColorPicker = !showColorPicker;
                changeColorType = 2;
              "
            ></div>
          </template>
        </van-field>
        <van-field name="radio" label="经过夹层">
          <template #input>
            <van-radio-group v-model="form.isPassed" direction="horizontal">
              <van-radio
                v-for="(item, index) in isPassedOption"
                :key="index"
                :name="item.value"
                >{{ item.label }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>
        <!-- <van-field name="radio" label="提交类型" v-show="form.isPassed">
          <template #input>
            <van-radio-group
              v-model="form.submissionType"
              direction="horizontal"
            >
              <van-radio
                v-for="(item, index) in submissionTypeOption"
                :key="index"
                :name="item.value"
                >{{ item.label }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field> -->
        <van-field name="switch" label="开启状态">
          <template #input>
            <van-switch
              v-model="form.isEnabled"
              size="20"
              :active-value="1"
              :inactive-value="0"
            />
          </template>
        </van-field>
        <van-field
          v-show="!form.qrCodeImage"
          v-model="form.link"
          name="进件链接"
          label="进件链接"
          placeholder="请填写进件链接"
        />
        <van-field label="进件二维码" v-show="!form.link">
          <template #input>
            <van-uploader
              max-count="1"
              v-model="qrCodeImage"
              :after-read="linkAfterRead"
              @delete="imgDelete"
            />
          </template>
        </van-field>
        <div style="margin: 16px 16px 0 16px">
          <van-button round block type="info" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
    <!-- 颜色选择器 -->
    <van-popup v-model="showColorPicker" position="bottom">
      <div class="showColorPickerOption">
        <div v-for="(item, index) in colorPickerOption" :key="index">
          <span
            class="item"
            :style="{ backgroundColor: item }"
            @click="changeColor(item)"
          ></span>
        </div>

        <!-- <span class="item"></span> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getCurrentChannelInfo } from "@/api/login";
import {
  Form,
  Field,
  Button,
  RadioGroup,
  Radio,
  Switch,
  Uploader,
  Popup,
  Toast,
  Notify,
} from "vant";
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Switch);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Notify);
import Vue from "vue";
import {
  addXcLayerCode,
  getXcLayerCodeFormId,
  editXcLayerCode,
  getUrlByImg,
} from "@/api/layerCode";
import * as imageConversion from "image-conversion";
export default {
  components: {},
  data() {
    return {
      form: {
        layerName: "",
        isPassed: 1,
        submissionType: "user",
        isEnabled: 1,
        link: "",
        qrCodeImage: "",
        backgroundColor: "#E24D43",
        fontColor: "#FFFFFF",
        upstreamName: "",
        notes: "",
        channelCode: "",
      },
      qrCodeImage: [],
      selectedlcon: [],
      isPassedOption: [
        {
          value: 1,
          label: "经过",
        },
        {
          value: 0,
          label: "不经过",
        },
      ],
      submissionTypeOption: [
        {
          value: "user",
          label: "用户信息",
        },
        {
          value: "company",
          label: "企业信息",
        },
      ],
      showColorPicker: false,
      colorPickerOption: [
        "#E24D43",
        "#FFFFFF",
        "#F6F7F8",
        "#000000",
        "#4D4D4D",
        "#999999",
        "#CCCCCC",
        "#E8647E",
        "#E777E9",
        "#7C4BF2",
        "#586FF6",
        "#53A5EE",
        "#78F8FD",
        "#82D8CC",
        "#8EDD5D",
        "#D0E087",
        "#FCF250",
        "#F0C277",
        "#EDA777",
        "#C2AE80",
      ],
      changeColorType: "",
      isAdd: true,
    };
  },

  mounted() {
    let code = this.$route.query.code;
    if (code) {
      getXcLayerCodeFormId(code).then((res) => {
        this.form = res;
        if (res.qrCodeImage) {
          this.qrCodeImage = [];
          this.qrCodeImage.push({ url: res.qrCodeImage });
        }
        this.isAdd = false;
      });
    }
    getCurrentChannelInfo().then((res) => {
      this.form.channelCode = res.id;
    });
  },

  methods: {
    linkAfterRead(file) {
      console.log("file", file)
      Toast.loading({
        message: "上传中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      imageConversion.compressAccurately(file.file, 400).then((res) => {
        console.log("res", res);
        let img = new File([res], file.file.name, {
          type: file.file.type,
        });
        let data = new FormData();
        data.append("file", img);
        getUrlByImg(data).then((res) => {
          this.form.qrCodeImage = res;
          Toast.clear();
        });
      });
    },
    imgDelete() {
      this.qrCodeImage = [];
      this.form.qrCodeImage = "";
    },
    onSubmit() {
      if (!this.form.link && !this.form.qrCodeImage) {
        Notify({ type: "danger", message: "请填写申请链接或进件二维码" });
        return false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      if (this.isAdd) {
        addXcLayerCode(this.form).then((res) => {
          Notify({ type: "success", message: "新增成功" });
          this.$router.replace({ path: "/layerCode" });
        });
      } else {
        editXcLayerCode(this.form).then((res) => {
          Notify({ type: "success", message: "修改成功" });
          this.$router.replace({ path: "/layerCode" });
        });
      }
    },
    changeColor(color) {
      if (this.changeColorType == 1) {
        this.form.backgroundColor = color;
      }
      if (this.changeColorType == 2) {
        this.form.fontColor = color;
      }
      this.showColorPicker = false;
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/layerCode/module/layerCodeForm/index.vue